import { CreateVendorMutation } from "~/gql/mutations/vendor.generated";
import { GetVendorsQuery } from "~/gql/queries/vendor.generated";

export const vendorEndpoints = {
	CreateVendor: {
		transformResponse: (res: CreateVendorMutation) => res
	},
	GetVendors: {
		providesTags: ["Vendors"] as AddTagTypes,
		transformResponse: (res: GetVendorsQuery) => res
	}
};
